import { Component, Emit, Inject, Vue } from 'vue-property-decorator';
import { GoAppsComponent as GoApps, GoAccountComponent as GoAccount, GoLanguageComponent as GoLanguage } from '@gv/ammo-grome';
import LoginService from '@/account/login.service';
import AccountService from '@/account/account.service';
import TranslationService from '@/locale/translation.service';

@Component({
  name: 'SpeAppBar',
  components: {
    'go-apps': GoApps,
    'go-account': GoAccount,
    'go-language': GoLanguage,
  },
})
export default class SpeAppBar extends Vue {
  @Inject('loginService') private loginService!: () => LoginService;
  @Inject('translationService') private translationService!: () => TranslationService;
  @Inject('accountService') private accountService!: () => AccountService;

  public currentLanguage = '';
  private languages: any = this.$store.getters.languages;
  private hasAnyAuthorityValues = {};

  created(): void {
    this.currentLanguage = this.$store.getters.currentLanguage;
    this.translationService().refreshTranslation(this.currentLanguage);
    this.setDocumentTitle();
    this.$store.watch(
      () => this.$store.getters.currentLanguage,
      () => {
        this.currentLanguage = this.$store.getters.currentLanguage;
        this.setDocumentTitle();
      }
    );
  }

  mounted(): void {
    this.setDocumentTitle();
  }

  @Emit('drawerClick')
  // eslint-disable-next-line
  drawerBubbleUp() {}

  @Emit('drawerRightClick')
  // eslint-disable-next-line
  drawerRightBubbleUp() {}

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
    if (this.$vuetify) {
      this.$vuetify.lang.current = newLanguage.substring(0, 2);
    }
  }

  public isActiveLanguage(key: string): boolean {
    return key === this.$store.getters.currentLanguage;
  }

  public logout(): Promise<any> {
    return this.loginService()
      .logout()
      .then(response => {
        this.$store.commit('logout');
        window.location.href = response.data.logoutUrl;
        const next = response.data?.logoutUrl ?? '/';
        if (this.$route.path !== next) {
          return this.$router.push(next);
        }
      });
  }

  public openLogin(): void {
    this.loginService().login();
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  public hasAnyAuthority(authorities: any): boolean {
    this.accountService()
      .hasAnyAuthorityAndCheckAuth(authorities)
      .then(value => {
        if (this.hasAnyAuthorityValues[authorities] !== value) {
          this.hasAnyAuthorityValues = { ...this.hasAnyAuthorityValues, [authorities]: value };
        }
      });
    return this.hasAnyAuthorityValues[authorities] ?? false;
  }

  /**
   * Sets document.title from the i18n key `global.application.title`.
   * Retries every 300 ms (up to 3 s) because translations load asynchronously —
   * VueI18n returns the raw key when the bundle hasn't arrived yet.
   */
  private setDocumentTitle(): void {
    let elapsedTime = 0;
    const interval = 300;
    const maxTime = 3000;
    const attemptSetTitle = () => {
      const title = this.$t('global.application.title').toString();
      if (title !== 'global.application.title' || elapsedTime >= maxTime) {
        document.title = title;
        clearInterval(timer);
      } else {
        elapsedTime += interval;
      }
    };
    const timer = setInterval(attemptSetTitle, interval);
  }
}
